import React from 'react';
import styles from './CustomRadio.module.css';

type CustomRadioProps = {
    id: string;
    options: option[];
    name: string;
    onChange: Function;
    className?: string;
}

type option = {
    value: string;
    label: string;
    disabled?: boolean;
    checked?: boolean;
}

const CustomRadio = (props: CustomRadioProps) => {
    return (
        <div className={`${styles.container_radio} ${props.className}`}>
            { props.options.map((item, index) => {
                return (
                    <span>
                        <input
                            type="radio"
                            id={`${props.id}-${item.value}`}
                            name={props.name}
                            value={item.value}
                            onChange={(e) => props.onChange(e.target.value)}
                            disabled={item.disabled}
                            defaultChecked={item.checked}
                        />
                        <label htmlFor={`${props.id}-${item.value}`}>{item.label}</label>
                    </span>
                );
            })}
        </div>
    );
}

export default CustomRadio;